import React from 'react'
import { useSelector } from 'react-redux'
import { user as getUser } from '~data/selectors/user'
import { Avatar } from '~ui'

export default function UserAbout({ className='' }) {
    const user = useSelector(state=>getUser(state))

    return (
        <div className={'ui-about'+' '+className}>
            <Avatar 
                className={'ui-about-avatar'}
                enlarge='2'
                src={user.avatar} />

            <div className={'ui-about-name'}>{user.name}</div>
            <div className={'ui-about-email'}>{user.email}</div>
        </div>
    )
}